var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "20px",
    height: "30px",
    viewBox: "0 0 34.65 34.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    className: "fil0",
    d: "M25.27 17.33c-2.79,0 -5.05,2.26 -5.05,5.05 0,2.79 2.26,5.05 5.05,5.05l9.39 0 0 7.22 -34.65 0 0 -24.55 34.65 0 0 7.22 -9.39 0zm1.44 7.22l-1.44 0c-1.2,0 -2.17,-0.97 -2.17,-2.17 0,-1.2 0.97,-2.17 2.17,-2.17l1.44 0c1.2,0 2.17,0.97 2.17,2.17 0,1.2 -0.97,2.17 -2.17,2.17l0 0zm-3.61 -24.55l4.99 8.41 -25.78 0.12 20.8 -8.52 0 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.dec4409dbbf74e10842d90f5872af14c.svg";
export { ForwardRef as ReactComponent };